import { Dropdown, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TaskTypeStatus } from '@econtractor/types';
import SolarIcon from 'components/icons/SolarIcon';
import { TaskStatusBadge } from 'modules/task';

const TASK_REPORT_STATUSES = [
    TaskTypeStatus.NEW,
    TaskTypeStatus.INWORK,
    TaskTypeStatus.COMPLETED,
    TaskTypeStatus.ACCEPTED,
];

interface TaskStatusFilterProps {
    value: number[];
    onChange: (value: number[]) => void;
    showZeroTasks: boolean;
    onShowZeroTasksChange: (value: boolean) => void;
    disabled?: boolean;
}

const isDefaultSelection = (value: number[], showZeroTasks: boolean): boolean =>
    !showZeroTasks && value.length === 1 && Number(value[0]) === TaskTypeStatus.ACCEPTED;

const TaskStatusFilter = ({
    value,
    onChange,
    showZeroTasks,
    onShowZeroTasksChange,
    disabled,
}: TaskStatusFilterProps) => {
    const { t } = useTranslation(['Reports']);
    const selected = new Set(value.map((status) => Number(status)));

    const toggle = (status: number) => {
        if (selected.has(status)) {
            onChange(value.filter((item) => Number(item) !== status));
            return;
        }
        onChange([...value, status]);
    };

    return (
        <Dropdown autoClose="outside">
            <Dropdown.Toggle
                className="fs-14 px-2"
                size="sm"
                variant={isDefaultSelection(value, showZeroTasks) ? 'primary' : 'danger'}
                id="report-tasks-status-filter"
                disabled={disabled}
                title={t('tasksFilter.title')}
            >
                <SolarIcon name="funnel" className="fs-14 p-0" />
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <div className="px-3 py-2 d-flex flex-column gap-2" onClick={(e) => e.stopPropagation()}>
                    {TASK_REPORT_STATUSES.map((status) => (
                        <Form.Check
                            key={status}
                            type="checkbox"
                            id={`report-tasks-status-${status}`}
                            className="mb-0 text-nowrap"
                            label={<TaskStatusBadge status={status} />}
                            checked={selected.has(status)}
                            onChange={() => toggle(status)}
                        />
                    ))}
                    <Form.Check
                        type="checkbox"
                        id="report-tasks-show-zero"
                        className="mb-0 mt-1 pt-1 border-top text-nowrap"
                        label={t('tasksFilter.showZero')}
                        checked={showZeroTasks}
                        onChange={() => onShowZeroTasksChange(!showZeroTasks)}
                    />
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default TaskStatusFilter;
